export const CONTENT = 1000;
